var map = {
	"./cat": "20e1",
	"./cat.js": "20e1",
	"./cd": "5d6c",
	"./cd.js": "5d6c",
	"./chmod": "7517",
	"./chmod.js": "7517",
	"./common": "bd9a",
	"./common.js": "bd9a",
	"./cp": "66c6",
	"./cp.js": "66c6",
	"./dirs": "8d3b",
	"./dirs.js": "8d3b",
	"./echo": "a022",
	"./echo.js": "a022",
	"./error": "5b67",
	"./error.js": "5b67",
	"./exec": "034b",
	"./exec-child": "b43d",
	"./exec-child.js": "b43d",
	"./exec.js": "034b",
	"./find": "c181",
	"./find.js": "c181",
	"./grep": "5259",
	"./grep.js": "5259",
	"./head": "1b1d",
	"./head.js": "1b1d",
	"./ln": "f16b",
	"./ln.js": "f16b",
	"./ls": "b6d1",
	"./ls.js": "b6d1",
	"./mkdir": "08c6",
	"./mkdir.js": "08c6",
	"./mv": "5600",
	"./mv.js": "5600",
	"./popd": "d0b6",
	"./popd.js": "d0b6",
	"./pushd": "47be",
	"./pushd.js": "47be",
	"./pwd": "83d6",
	"./pwd.js": "83d6",
	"./rm": "acb1",
	"./rm.js": "acb1",
	"./sed": "5bbb5",
	"./sed.js": "5bbb5",
	"./set": "94d9",
	"./set.js": "94d9",
	"./sort": "aa4f",
	"./sort.js": "aa4f",
	"./tail": "2837",
	"./tail.js": "2837",
	"./tempdir": "de84",
	"./tempdir.js": "de84",
	"./test": "ca75",
	"./test.js": "ca75",
	"./to": "57a3",
	"./to.js": "57a3",
	"./toEnd": "b9c5",
	"./toEnd.js": "b9c5",
	"./touch": "2007",
	"./touch.js": "2007",
	"./uniq": "b6a7",
	"./uniq.js": "b6a7",
	"./which": "5089",
	"./which.js": "5089"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2435";